import Recipes from './Recipes'

export default Recipes
// eslint-disable-next-line import/export
export * from './Recipes'
